<template>
  <div id="app" class="font-sans bg-white text-neutral-900 antialiased">
    <Navbar />
    <router-view/>
    <AppFooter />
    <ToolDetailModal />
    <RequestDetailModal />
    <AskBotModal />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import AppFooter from './components/Footer.vue'
import ToolDetailModal from './components/ToolDetailModal.vue'
import RequestDetailModal from './components/RequestDetailModal.vue'
import AskBotModal from './components/AskBotModal.vue'
import { loadPointConfig } from './utils/pointConfig'
import { loadDownloadFree } from './utils/downloadRule'
import { loadUploadConfig } from './utils/uploadConfig'

export default {
  name: 'App',
  components: {
    Navbar,
    AppFooter,
    ToolDetailModal,
    RequestDetailModal,
    AskBotModal
  },
  created() {
    // 加载后台配置的创值规则（下载消耗等），失败则用默认值
    loadPointConfig(this.$axios);
    // 加载当前用户是否属于免创值群体（义乌教师）
    loadDownloadFree(this.$axios);
    // 加载后台配置的上传大小限制（图片/附件/ZIP），失败则用默认值
    loadUploadConfig(this.$axios);
  },
  mounted() {
    this.startHeartbeat();
    this.autoOpenFromUrl();
  },
  beforeUnmount() {
    clearInterval(this._heartbeatTimer);
  },
  methods: {
    /**
     * 分享链接支持：访问 /?tool=工具id 时自动弹出该工具详情
     */
    autoOpenFromUrl() {
      try {
        const params = new URLSearchParams(window.location.search);
        const toolId = params.get('tool');
        if (toolId) {
          // 兼容旧分享链接 /?tool=id：直接跳转到该工具的专属页面
          this.$router.replace('/tool/' + toolId);
        }
      } catch (e) {
        /* 解析失败忽略 */
      }
    },

    /**
     * 在线时长心跳：登录状态下每 60 秒上报一次（+1 分钟在线时长）
     * 用 localStorage 时间戳做全局节流，多标签页不重复计时
     */
    startHeartbeat() {
      this._heartbeatTimer = setInterval(async () => {
        const token = localStorage.getItem('token');
        if (!token) return;
        // 全局节流：55 秒内已有其他标签页上报过则跳过
        const last = parseInt(localStorage.getItem('_hb_last') || '0', 10);
        if (Date.now() - last < 55 * 1000) return;
        try {
          localStorage.setItem('_hb_last', String(Date.now()));
          await this.$axios({ url: 'user/heartbeat', method: 'POST', data: {} });
        } catch (e) {
          /* 心跳失败静默忽略 */
        }
      }, 60 * 1000);
    },
  }
}
</script>
